export const NEXT_VIEW = 'NEXT_VIEW';
export const SET_DIRECTION_LIST = 'SET_DIRECTION_LIST';
export const SET_TITLE = 'SET_TITLE';
export const SET_CONTENT = 'SET_CONTENT';
export const SET_AVAILABLE_AT = 'SET_AVAILABLE_AT';
export const REQ_UPGRADE_PERSONA = 'REQ_UPGRADE_PERSONA';
export const REQ_UPGRADE_MANUAL = 'REQ_UPGRADE_MANUAL';